import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc6BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const fungiBoolStats = itemsByField["bloc6.fungiBool"]?.stats || null;
  const fungiTypeStats = itemsByField["bloc6.fungiType"]?.stats || null;
  const lichenBoolStats = itemsByField["bloc6.lichenBool"]?.stats || null;
  const lichenTypeStats = itemsByField["bloc6.lichenType"]?.stats || null;
  const bacteriaBoolStats = itemsByField["bloc6.bacteriaBool"]?.stats || null;
  const bacteriaTypeStats = itemsByField["bloc6.bacteriaType"]?.stats || null;

  const fungiBoolChartItems = [
    { category: "Sí", count: fungiBoolStats?.yes || 0 },
    { category: "No", count: fungiBoolStats?.no || 0 },
  ];
  const fungiTypeChartItems = (fungiTypeStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));
  const lichenBoolChartItems = [
    { category: "Sí", count: lichenBoolStats?.yes || 0 },
    { category: "No", count: lichenBoolStats?.no || 0 },
  ];
  const lichenTypeChartItems = (lichenTypeStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));
  const bacteriaBoolChartItems = [
    { category: "Sí", count: bacteriaBoolStats?.yes || 0 },
    { category: "No", count: bacteriaBoolStats?.no || 0 },
  ];
  const bacteriaTypeChartItems = (bacteriaTypeStats?.items || []).map(
    (item) => ({
      category: item.category,
      count: item.count,
    })
  );

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc6.loading", "Carregant estadístiques de bloc6…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <BooleanStatsPanel
            title={t("dashboard.blocks.bloc6.fungiPresence", "Presència de fongs")}
            stats={fungiBoolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc6.fungiTypes", "Tipus de fongs")}
            stats={fungiTypeStats}
          />
          <BooleanStatsPanel
            title={t(
              "dashboard.blocks.bloc6.lichenPresence",
              "Presència de líquens"
            )}
            stats={lichenBoolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc6.lichenTypes", "Tipus de líquens")}
            stats={lichenTypeStats}
          />
          <BooleanStatsPanel
            title={t(
              "dashboard.blocks.bloc6.bacteriaPresence",
              "Presència de bacteris"
            )}
            stats={bacteriaBoolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc6.bacteriaTypes", "Tipus de bacteris")}
            stats={bacteriaTypeStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.yesNoFungi",
              "Respostes sí/no sobre fongs"
            )}
            items={fungiBoolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.fungiTypeDistribution",
              "Distribució de tipus de fongs"
            )}
            items={fungiTypeChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.yesNoLichens",
              "Respostes sí/no sobre líquens"
            )}
            items={lichenBoolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.lichenTypeDistribution",
              "Distribució de tipus de líquens"
            )}
            items={lichenTypeChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.yesNoBacteria",
              "Respostes sí/no sobre bacteris"
            )}
            items={bacteriaBoolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc6.bacteriaTypeDistribution",
              "Distribució de tipus de bacteris"
            )}
            items={bacteriaTypeChartItems}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
